import { render, staticRenderFns } from "./SubCatalogsList.vue?vue&type=template&id=cf9a39c8&scoped=true"
import script from "./SubCatalogsList.vue?vue&type=script&lang=js"
export * from "./SubCatalogsList.vue?vue&type=script&lang=js"
import style0 from "./SubCatalogsList.vue?vue&type=style&index=0&id=cf9a39c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9a39c8",
  null
  
)

export default component.exports